import languages, { alternateLanguages } from "config/languages";
import type { LanguageCode } from "config/languages";
import type { CMSLanguagesData } from "contexts/DataContext/hooks.d";
import { getPageUrl } from "utils/getPageUrl";
import type { PageName } from "utils/getPageUrl/types";
import { getSlugWithoutLocale } from "utils/getSlugWithoutLocale";
import { isDefaultLanguage } from "utils/isDefaultLanguage";
import type { Hreflang } from "./getHreflangs.d";

const buildLanguageData = (
  langs: Record<LanguageCode, string>,
  cmsLanguagesData: CMSLanguagesData[],
  pageName?: PageName
): Record<LanguageCode, Hreflang> =>
  Object.keys(langs).reduce((obj, language: LanguageCode) => {
    const languageObject = obj;
    let localizedPagePath = "";

    if (cmsLanguagesData?.length) {
      const cmsPageData = cmsLanguagesData.filter((item) => {
        const locale = item.full_slug.split("/")[0] as LanguageCode;
        const isParentLanguageSame = locale.split("-")[0] === language.split("-")[0];

        return isDefaultLanguage(locale) ? isParentLanguageSame : locale === language;
      });
      const slug = cmsPageData.length && getSlugWithoutLocale(cmsPageData[0].full_slug);
      localizedPagePath = slug ? `/${language}/${slug}` : `/${language}/`;
    } else {
      localizedPagePath = getPageUrl(language, pageName);
    }

    languageObject[language] = {
      languageCode: language,
      languageName: langs[language],
      href: localizedPagePath.replace(`//`, "/"),
      flag: languages.get(language).languageFlag,
    };

    return languageObject as Record<LanguageCode, Hreflang>;
  }, {} as Record<LanguageCode, Hreflang>);

export const getHreflangs = (cmsLanguagesData: CMSLanguagesData[], pageName?: PageName) => {
  const availableLanguageVersions = cmsLanguagesData
    ?.map((item) => item.full_slug.split("/")[0] as LanguageCode)
    .reduce((obj, item) => {
      const cmsObj = obj;
      if (alternateLanguages[item]) {
        alternateLanguages[item].map((lang) => {
          const language = languages.get(lang);

          cmsObj[lang] = language.name;
          return lang;
        });
        return cmsObj;
      }
      const language = languages.get(item);
      if (!language || language.hidden) return obj;

      cmsObj[item] = language.name;
      return cmsObj;
    }, {} as Record<LanguageCode, string>);

  const hreflangs = buildLanguageData(availableLanguageVersions, cmsLanguagesData, pageName);

  return hreflangs;
};
